import { Component, Input, TemplateRef, ContentChild } from '@angular/core';

@Component({
  selector: 'rms-tab',
  template: ''
})
export class RmsTabComponent {
  @Input() label!: string;
  @Input() active: boolean = false;
  @ContentChild(TemplateRef) template!: TemplateRef<any>;
}
